module.exports = __webpack_public_path__ + "img/video-plus.0b3ac5cc.svg";